/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedOrderTaxableSupplyDateRequest } from '../types/PatchedOrderTaxableSupplyDate';
import type { OrderTaxableSupplyDateResponse } from '../types/OrderTaxableSupplyDate';

export type OrdersTaxableSupplyDatePartialUpdateRequest = PatchedOrderTaxableSupplyDateRequest;
export type OrdersTaxableSupplyDatePartialUpdateResponse = OrderTaxableSupplyDateResponse;

export type OrdersTaxableSupplyDatePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/orders/{id}/taxable_supply_date/
 *
 * ```yaml
 * operationId: orders_taxable_supply_date_partial_update
 * description: >-
 *   Nastaví datum uskutečnění zdanitelného plnění (DUZP) na objednávce.
 *
 *
 *   Admin ho zadává před schválením — vstup do daňového dokladu. Mění jen tohle
 *   pole,
 *
 *   nespouští přepočet ani přestavbu objednávky jako běžný PATCH.
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderTaxableSupplyDate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderTaxableSupplyDate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderTaxableSupplyDate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderTaxableSupplyDate'
 *     description: ''
 * ```
 */
export const ordersTaxableSupplyDatePartialUpdateOperation = ({
  id,
  ...rest
}: OrdersTaxableSupplyDatePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/orders/${id}/taxable_supply_date/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/orders/{id}/taxable_supply_date/' };
  };

/**
 * PATCH /dmx-server/orders/{id}/taxable_supply_date/
 *
 * ```yaml
 * operationId: orders_taxable_supply_date_partial_update
 * description: >-
 *   Nastaví datum uskutečnění zdanitelného plnění (DUZP) na objednávce.
 *
 *
 *   Admin ho zadává před schválením — vstup do daňového dokladu. Mění jen tohle
 *   pole,
 *
 *   nespouští přepočet ani přestavbu objednávky jako běžný PATCH.
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderTaxableSupplyDate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderTaxableSupplyDate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedOrderTaxableSupplyDate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderTaxableSupplyDate'
 *     description: ''
 * ```
 */
export const ordersTaxableSupplyDatePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrdersTaxableSupplyDatePartialUpdateQuery;
  request: PatchedOrderTaxableSupplyDateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderTaxableSupplyDateResponse>> => {
  const operation = ordersTaxableSupplyDatePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
